import { AuthContextProvider, createOidcAuthorizedRoutes, DefaultLoginView, DefaultLogoutView, OidcContext } from "@org-avp/avp-avengers-ui-shared-auth";
import { getRouterPath, viewRegistry } from "@org-avp/avp-avengers-ui-shared-utils";
import { HomeView } from "@org-avp/avp-avengers-ui-views-home";
import { createBrowserRouter, redirect, RouteObject } from "react-router-dom";
import { AppShell } from "../components/app-shell/AppShell";
import { DetachedView } from "../components/detached-view/DetachedView";
import { RouteError } from "../components/route-error/RouteError";

export const createRouter = () => {
  const router = createBrowserRouter(
    createOidcAuthorizedRoutes({
      oidcContext: OidcContext.DEFAULT,
      errorComponent: () => <RouteError/>,
      loginComponent: (oidcAppConfiguration) => (
        <DefaultLoginView oidcAppConfiguration={oidcAppConfiguration}/>
      ),
      logoutComponent: (oidcAppConfiguration) => (
        <DefaultLogoutView oidcAppConfiguration={oidcAppConfiguration}/>
      ),
      unguardedRoutes: [
        {
          path: "/load-subproject/:projectId/:subprojectId",
          loader: ({ params: { projectId, subprojectId } }) => {
            return redirect(`/app/project/${projectId}/${subprojectId}`);
          },
        },
      ],
      guardedRoutes: [
        {
          path: "/",
          element: <AppShell/>,
          children: [
            ...createRoutesFromViews(),
            { path: "/", element: <HomeView/> },
          ],
        },
        {
          children: [
            ...createRoutesFromModularViews(),
            ...createRoutesFromOidcContexts(),
          ],
        },
      ],
    }),
  );
  console.log("Router created");
  return router;
};

const createRoutesFromModularViews = (): RouteObject[] => {
  return Array.from(viewRegistry.getViews({ type: "modular" }).values())
    .map((view) => ({
      path: getRouterPath(view),
      element: (
        <DetachedView view={view}/>
      ),
    }));
};

const createRoutesFromViews = (): RouteObject[] => {
  return Array.from(viewRegistry.getViews({ type: "fullSize" }).values())
    .map((view) => ({
      path: getRouterPath(view),
      element: view.viewEl,
    }));
};

const createRoutesFromOidcContexts = (): RouteObject[] => {
  return Object.values(OidcContext)
    .filter((it) => it !== OidcContext.DEFAULT)
    .flatMap((oidcContext) => ({
      element: <AuthContextProvider oidcContext={oidcContext}/>,
      path: `/${oidcContext}/*`,
    }));
};
